export default "__VITE_ASSET__BqNR7Hly__"